import React, { useMemo } from 'react';
import {
  findPartnershipSplitsInRoster,
  describePartnershipSplit,
} from '../../utils/partnershipRosterUtils';

/**
 * Inline notice when a court/upcoming roster splits session partnership(s).
 */
export default function PartnershipSplitNotice({
  team1 = [],
  team2 = [],
  partnerships = [],
  playersById = {},
  className = '',
}) {
  const splits = useMemo(
    () => findPartnershipSplitsInRoster(team1, team2, partnerships),
    [team1, team2, partnerships],
  );

  if (!splits.length) return null;

  const detail = splits
    .map((split) => describePartnershipSplit(split, playersById))
    .join('; ');

  return (
    <div
      className={`rounded-lg border border-warning/40 bg-warning-light/20 px-3 py-2 text-xs leading-snug text-text-secondary ${className}`}
      role="status"
    >
      <span className="font-semibold text-warning-dark">Partnership split</span>
      <span className="text-text-secondary"> — </span>
      {detail}.
    </div>
  );
}
